import { ClickTapHandler } from '../methods/ui-click-tap-event-handler';

export default () => ({

    Video: null,
    isVideoElement: false,
    videoIsPlaying: false,

    onClickToggleVideo( event ) {
        // console.log( 'onClickToggleVideo', { event } );
        event.preventDefault();
        this.togglePlay();
    },

    toggleVideoClass() {
        this.videoIsPlaying = !this.Video.paused;
    },

    togglePlay() {
        let element = this.Video;
        if (element.paused) {
            element.play();
        } else {
            element.pause();
        }
        this.toggleVideoClass(); // Update classes based on new state
    },

    init() {
        console.log( 'Standalone Video', { "this": this, "$root": this.$root, '$video': this.$root.querySelector( 'video' ) } );

        let element;

        this.Video = this.$root.querySelector( 'video' );

        if( !this.Video ) {
            return;
        }

        element = this.Video;
        this.isVideoElement = true;
        // console.log( 'Standalone Video', { element } );


        // Event listeners for play and pause events
        element.addEventListener( 'play', this.toggleVideoClass.bind( this ) );// todo: likely needs binding
        element.addEventListener( 'pause', this.toggleVideoClass.bind( this ) );// todo: likely needs binding

        // Handle case where video is manually paused via UI slider or ends
        element.addEventListener('ended', () => {
            element.classList.add('paused');
            element.classList.remove('playing');
        });


        new ClickTapHandler( element, this.onClickToggleVideo.bind( this ) );
        // todo: detect whether `<video>` element has the `controls` attribute before layering on the click handling

    }
});
